var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGaussTurret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M115.269 29.592C115.119 28.4745 113.819 26.7195 113.819 26.7195L115.001 25.284L112.835 24.0285L110.778 25.791C110.778 25.791 110.969 26.2935 111.501 27.8175C112.032 29.343 111.708 30.195 111.708 30.195H110.61L109.662 28.026L108.432 25.9875L106.133 24.9795L101.234 23.595L100.98 22.7505L95.5741 22.074L95.0671 20.976H91.8466V21.708C91.8466 21.708 87.4231 21.9375 85.8661 22.0185C84.3091 22.0995 79.9426 21.7335 77.7301 21.3045C75.5191 20.877 74.2456 19.5405 74.2456 19.5405L73.5691 15.2325L69.7261 2.68951L66.3901 3.39301V13.2045C66.3901 13.2045 65.6296 15.231 63.0451 15.231C60.4606 15.231 60.0001 12.6975 60.0001 12.6975V4.84201H57.0841L54.5206 13.3305H51.4396V19.539L46.5241 15.105H12.2881L9.58506 19.7925V22.749H6.88205L6.71255 27.3105H9.92256V31.956H3.08105V35.757C3.08105 35.757 15.2491 40.044 16.4281 40.269C17.6056 40.494 18.6241 40.4025 18.6241 40.4025L42.7816 40.065L45.1891 40.269L48.6106 40.4025C48.6106 40.4025 44.1016 53.5125 44.0491 53.664C43.9966 53.8155 44.0491 54.8235 45.0061 55.212C45.9631 55.6005 47.2306 54.7845 47.2306 54.7845L50.4961 55.5225L50.5906 56.0055C50.5906 56.0055 51.1741 56.7795 51.8191 56.919C52.4641 57.0585 54.0811 56.748 54.6181 56.4375C55.1551 56.127 55.4011 55.2765 55.4011 55.2765L64.3201 40.965L70.4866 38.037L72.9721 38.2545L74.0341 39.6135V42.429L76.0621 44.2035H77.7511L78.9331 44.8785H84.8461C87.3241 44.8785 86.7886 42.921 86.7886 42.921C86.7886 42.921 86.5351 41.865 86.7886 40.317C87.0421 38.769 89.0131 38.712 89.0131 38.712H94.3906L99.0361 35.418L102.977 35.496L104.273 35.925H111.537L115.268 33.813C115.268 33.813 115.418 30.708 115.268 29.589L115.269 29.592ZM15.7516 18.8355L13.0486 20.5245L11.6401 19.539L13.3861 16.977H15.7516V18.8355ZM93.6871 27.345L91.8856 28.704L89.0131 27.3105V25.9875H93.6871V27.3465V27.345ZM102.753 29.088H99.2056V27.537L100.329 26.28L101.627 25.986H102.753V29.088ZM105.456 27.537L107.597 29.088H105.456V27.537ZM110.412 32.856L108.272 34.182H106.131V30.9975H110.411V32.856H110.412Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9582 27.9586H24.7052V33.2521H26.9582V27.9586Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9521 27.9586H36.6991V33.2521H38.9521V27.9586Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2277 26.2411H21.0872L23.9597 22.1866H26.0987L23.2277 26.2411Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2217 26.2411H33.0812L35.9537 22.1866H38.0942L35.2217 26.2411Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.853 26.2411H44.714L47.585 22.1866H49.7255L46.853 26.2411Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8372 21.6511V31.9561",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0128 16.9771L27.5353 18.7516",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1627 27.8176L18.6837 29.5921",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5681 27.8176L31.0891 29.5921",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3341 27.8176L42.8566 29.5921",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1016 16.9771L39.6241 18.7516",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.819 20.5245V22.608L45.54 31.956L47.004 33.8145L45.54 40.269",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7677 38.0385H76.1172L78.5952 39.615V40.9665V44.76",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5958 40.9666L80.6868 42.7681V44.8801",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8372 24.9796H21.7772",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4232 24.9796H33.9752",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.9796H45.5399",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6095 31.5061L50.975 29.5921H58.8875L60.8585 31.1956",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60 25.9875H55.452V27.8175H60V25.9875Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6075 13.3306H60",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3201 17.6821H58.3231L57.3031 18.3856H51.4396",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4092 24.7081H60.2387L63.2222 22.8346L66.2642 22.7491",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6216 26.241H77.1886V29.088H82.3681",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92353 30.195V27.3105H6.71353V22.749H9.58603V19.7925H5.27803C5.27803 19.7925 3.08203 19.455 3.08203 21.06V27.141",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58506 19.7925L12.2881 15.105H46.5241L51.4396 19.539V13.3305H54.6076L57.0856 4.84199H60.0016V12.6975C60.0016 12.6975 61.2226 15.105 63.0466 15.231C64.8706 15.357 66.3916 13.2045 66.3916 13.2045V3.39149L69.7276 2.68799L73.5721 15.231L74.2486 19.539C74.2486 19.539 75.5686 21.9465 84.7906 22.0725L91.8481 21.7065V20.9745H95.0686L95.5756 22.0725L101.235 22.833V23.5935C101.235 23.5935 107.993 25.1145 108.753 26.2965C109.514 27.4785 110.612 30.1935 110.612 30.1935H111.71C111.71 30.1935 111.879 29.421 111.71 28.5765C111.54 27.732 110.781 25.7895 110.781 25.7895L113.147 23.763L115.005 25.284L113.823 26.7195C113.823 26.7195 115.682 28.155 115.428 32.2095L115.452 33.8145L111.543 35.9265H104.279L103.35 35.5035L99.0421 35.4195L94.3966 38.7135H88.4836C88.4836 38.7135 86.7946 38.7975 86.7946 40.3185V43.359C86.7946 43.359 86.9641 44.88 85.3591 44.88H78.7291L78.0106 44.205H76.0681L74.0416 42.4305V39.39L72.7741 38.0385H70.4941L63.8746 41.586L55.2046 55.608C55.2046 55.608 54.8671 57.213 52.1641 56.9595C49.4611 56.706 50.9821 55.524 50.9821 55.524L47.0116 54.786C47.0116 54.786 46.2511 55.4385 44.8996 55.3545C43.5481 55.2705 44.0551 53.6655 44.0551 53.6655L48.6166 40.404C48.6166 40.404 43.8871 40.2345 42.7876 40.0665C41.6896 39.897 18.6301 40.404 18.6301 40.404C18.6301 40.404 16.8556 40.5735 14.0686 39.729C11.2816 38.8845 3.08705 35.7585 3.08705 35.7585V31.9575H9.92856V30.1965H3.08105",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7051 31.956H9.92407",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.699 31.956H26.958",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0447 15.231C63.0447 15.231 64.4052 15.4845 64.3197 17.6805C64.3197 17.6805 66.0942 19.623 66.2622 22.749L65.5872 27.141L63.2217 31.1955H60.8562C59.9277 32.463 58.9977 33.8145 56.2107 34.152C53.4237 34.4895 50.0442 31.956 50.0442 31.956H38.9502",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.222 31.1955L50.9745 55.5225",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6094 40.4025H58.5874",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.819 40.4025L47.004 54.786",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2452 19.5391C74.2452 19.5391 74.2032 24.2971 73.3587 26.0431C72.5142 27.7891 63.8682 41.5846 63.8682 41.5846",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92407 27.3105V21.651H15.7516L17.4976 20.5245H59.5621L60.7456 19.539H65.2501",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.498 20.5245V15.231",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.233 23.5935C101.233 23.5935 101.74 25.593 101.628 25.9875C101.515 26.382 98.25 26.325 98.25 26.325L96.786 25.9875H82.8765L81.9195 26.9445V29.088H97.236V31.1115H99.939L100.164 32.238L98.25 33.8145L96.8415 32.688H74.247V31.3935H70.089",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4735 34.1835H92.8995V38.7135",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.248 33.8145V35.979",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0137 25.9874V27.3104L91.8862 28.7039L93.6877 27.3464V25.9874H89.0137Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M101.629 25.9874H102.754V29.0879H99.2062V27.5384L100.33 26.2799L101.629 25.9874Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M106.133 30.9989V34.1834H108.272L110.412 32.8574V30.9989H106.133Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M105.457 27.5385V29.088H107.598L105.457 27.5385Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7516 16.977V18.8355L13.0486 20.5245L11.6416 19.539L13.3861 16.977H15.7516Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaussTurret);
export default __webpack_public_path__ + "static/media/Gauss Turret.dc864c562db56928ad82ed03ef243bc1.svg";
export { ForwardRef as ReactComponent };